$(document).ready(function () {
  /* collection */
  if ($(".templateCollection").length) {
    let path = window.location.pathname;
    $(".collect_front_menu_nav2 li").each(function () {
      let link = $(this).find("a").attr("href");
      let collectionName = $(this).text();
      if (link == path) {
        $(".dietary_option_nv_link2").text(collectionName);
        return false;
      }
    });
  }

  /* mobile nav submenu */

  $("#mobile_menu_full_nav_unreal .full_nav li.has-children").on(
    "click",
    function (e) {
      //e.preventDefault();
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).find(".sub-menu-mobile").slideUp(200);
      } else {
        $(this).addClass("active");
        $(".sub-menu-mobile").slideUp(200);
        $(this).find(".sub-menu-mobile").slideDown(200);
      }
    }
  );
});

// MINI CART STUFF
if (window.CartJS) {
  $(document).on("cart.requestComplete", function (event, cart) {
    const count = cart.item_count;
    $(".site-header__cart-count").text(cart.item_count);
    openCart();
  });
}

// RIVETS STUFF
if (window.rivets) {
  if (!window.CROSS_SELL_CONTROLLER) {
    CROSS_SELL_CONTROLLER = {
      CROSS_SELLS: undefined,
      CROSS_SELL_COUNT: 0,
    };
  }
  function initializeCrossSells() {
    const flickityOptions = {
      wrapAround: true,
      prevNextButtons: false,
      cellAlign: "left",
    };
    if (window.Flickity && CROSS_SELL_CONTROLLER.CROSS_SELL_COUNT > 1) {
      CROSS_SELL_CONTROLLER.CROSS_SELLS = new Flickity(
        ".mini-cart_cross-sells",
        flickityOptions
      );
    }
  }
  function destroyCrossSells() {
    if (CROSS_SELL_CONTROLLER.CROSS_SELLS) {
      CROSS_SELL_CONTROLLER.CROSS_SELLS.destroy();
      CROSS_SELL_CONTROLLER.CROSS_SELLS = undefined;
    }
  }

  rivets.binders["cross-sells"] = function () {
    initializeCrossSells();
  };
  rivets.binders["style-*"] = function (el, value) {
    el.style.setProperty(this.args[0], value);
  };
  rivets.binders["cart-js-add-to-cart"] = function (el) {
    // Add to cart if CartJS Present
    if (window.CartJS) {
      $(el).on("click", function () {
        CartJS.addItem(el.dataset.productId, 1);
      });
    }
  };
  rivets.formatters.jsonStringify = function (val) {
    return JSON.stringify(val);
  };
  rivets.formatters.hasVisibleCrossSells = function (cartItems) {
    return CROSS_SELL_CONTROLLER.CROSS_SELL_COUNT > 0;
  };

  rivets.formatters.itemIsBundleParent = function (itemProperties) {
    let isBundleParent = false;
    itemProperties.forEach((property) => {
      if (property.name === "_bundleId") {
        isBundleParent = true;
      }
    });
    return isBundleParent;
  };

  rivets.formatters.itemIsBundleChild = function (itemProperties) {
    let isBundleChild = false;
    itemProperties.forEach((property) => {
      if (property.name === "_bundleParentId") {
        isBundleChild = true;
      }
    });
    return isBundleChild;
  };

  rivets.formatters.itemIsNotBundleProduct = function (itemProperties) {
    let isBundle = true;
    itemProperties.forEach((property) => {
      if (property.name === "_boxItem") {
        isBundle = false;
      }
    });
    return isBundle;
  };

  rivets.formatters.deriveCrossSells = function (cartItems) {
    destroyCrossSells();

    const crossSells = [];
    const crossSellIds = [];
    const cartVariantIds = cartItems.map((item) => item.variant_id);
    const cartProductIds = cartItems.map((item) => item.product_id);
    if ("#CartCrossSells".length) {
      const productCrossSells = $.parseJSON(
        $("#CartCrossSells").html()
      ).crossSells;
      productCrossSells.forEach((product) => {
        const crossSellParent = Object.keys(product)[0];
        if (
          cartProductIds.includes(parseInt(crossSellParent)) ||
          cartVariantIds.includes(parseInt(crossSellParent))
        ) {
          product[crossSellParent].forEach((crossSell) => {
            // Make sure that it isn't in the cart
            if (
              !cartProductIds.includes(crossSell.id) &&
              !cartVariantIds.includes(crossSell.id)
            ) {
              if (!crossSellIds.includes(crossSell.id)) {
                // Only push if we don't already have it
                crossSells.push(crossSell);
                crossSellIds.push(crossSell.id);
              }
            }
          });
        }
      });
    }
    CROSS_SELL_CONTROLLER.CROSS_SELL_COUNT = crossSells.length;
    return crossSells;
  };
}

function closeCart() {
  $(".mini-cart").removeClass("open");
  $(".mini-cart_container").removeClass("open");
  $("html").css("overflow-y", "");
}
function openCart() {
  if (!$(".mini-cart.open").length) {
    $("html").css("height", "100vh");
    $("html").css("overflow-y", "hidden");
    $(".mini-cart_container").addClass("open");
    $(".mini-cart").addClass("open");
  }
  // initializeCrossSells();
}
$(document).ready(function () {
  $(".mini-cart_container").on("click", function (event) {
    if (
      !$(event.target).parents(".mini-cart").length &&
      !event.target.classList.contains("mini-cart")
    ) {
      closeCart();
    }
  });
  $(".list-group-item a#cart-opener").on("click", function (event) {
    event.preventDefault();
    openCart();
  });
  $("#cart-closer").on("click", function () {
    closeCart();
  });
});
